import { render, staticRenderFns } from "./xqkcxs.vue?vue&type=template&id=001bc670&"
import script from "./xqkcxs.vue?vue&type=script&lang=js&"
export * from "./xqkcxs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports